import { DatePipe, DecimalPipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { NavMenuService } from '../../../core/components/navmenu/navmenu.service';
import { ComponentBase } from '../../../core/_infrastructure/classes/componentBase';
import { ExceptionManager } from '../../../core/_infrastructure/classes/handlers/exceptionManager';
import { AuthService } from '../../../core/_infrastructure/classes/services/auth.service';
import { NotificationService } from '../../../core/_infrastructure/classes/services/notification.service';
import { ResumenAtestFitoService } from './resumen-list.service';
import { SolicitudAtestFitoService } from '../datosbasicos/datosbasicosAtestFito.service';
import { SolicitudAtestFitoResumenViewModel, ResumenSolicitudAtestFitoViewModel } from './resumen-list.types';

@Component({
    selector: 'app-resumen',
    templateUrl: './resumen-list.component.html',
})
/** solicitud-edit component*/
export class ResumenAtestFitoListComponent extends ComponentBase implements OnInit {
    /** solicitud-edit ctor */

    editMode = false;
    editTitle = 'Nuevo';

    solicitudResumenAtestFito: SolicitudAtestFitoResumenViewModel;
    resumenAtestFitoCollection: ResumenSolicitudAtestFitoViewModel[];
    tituloEstadoSolicitud: string;
    tituloTipoSolicitud: string;
    codigoTipoSolicitud: string;
    IdTipoSolicitudAtestFito: number;
    IdEstadoSolicitudAtestFito: number;
    refAtestFito: string;

    //EsSolicitante: boolean;
    //EsComunidad: boolean;
    //EsAgenteControl: boolean;

    numeroResumen = 0;

    colsResumen: any[];

    constructor(
        public datepipe: DatePipe,
        public decimalPipe: DecimalPipe,
        private activatedRoute: ActivatedRoute,
        private fb: UntypedFormBuilder,
        protected authService: AuthService,
        protected notificacionService: NotificationService,
        protected exceptionHandler: ExceptionManager,
        private navMenuService: NavMenuService,
        private solicitudAtestFitoService: SolicitudAtestFitoService,
        private resumenAtestFitoService: ResumenAtestFitoService,
    ) {
        super(authService, notificacionService, exceptionHandler);
    }

    ngOnInit() {
        let id = +this.activatedRoute.snapshot.params['id'];

        this.guardRefreshPage(id);

        this.createForm();

        if (id) {
            this.resumenAtestFitoService.getSolicitudResumenAtestFito(id).subscribe(result => {
                this.solicitudResumenAtestFito = result;
                this.IdTipoSolicitudAtestFito = this.solicitudResumenAtestFito.IdTipoSolicitudAtestFito;
                this.tituloTipoSolicitud = this.solicitudResumenAtestFito.IdTipoSolicitudAtestFitoDescripcion;
                this.tituloEstadoSolicitud = this.solicitudResumenAtestFito.IdEstadoSolicitudAtestFitoDescripcion;
                this.codigoTipoSolicitud = this.solicitudResumenAtestFito.CodigoTipoSolicitud;
                this.IdEstadoSolicitudAtestFito = this.solicitudResumenAtestFito.IdEstadoSolicitudAtestFito;
                this.refAtestFito = this.solicitudResumenAtestFito.RefAtestFito;

                this.resumenAtestFitoCollection = this.solicitudResumenAtestFito.TSolicitudAtestFitoSolicitudExCollection;

                this.updateForm();

                if (this.solicitudResumenAtestFito.TSolicitudAtestFitoSolicitudExCollection != null) {
                    this.numeroResumen = this.solicitudResumenAtestFito.TSolicitudAtestFitoSolicitudExCollection.length;
                } else {
                    this.numeroResumen = 0;
                }
            });
        }

        //Cambios Productos
        this.colsResumen = [
            { field: 'Link', header: '' },
            { field: 'Id', header: 'Id', display: 'none' },
            { field: 'RefAtestFito', header: 'Nº Atestación' },
            { field: 'CodigoSolicitudEx', header: 'Nº Solicitud Ex.' },
            { field: 'EstadoSolicitudEx', header: 'Estado Solicitud Ex.' },
            { field: 'FechaEnvio', header: 'Fecha Envío' },
            { field: 'PesoSolicitudEx', header: 'Peso (Kg)' },
            { field: 'UnidadesSolicitudEx', header: 'Unidades (Ud)' },
            { field: 'VolumenSolicitudEx', header: 'Volumen (m³)' },
        ];
    }

    createForm() {
        this.form = this.fb.group({
            TipoMedida: '',
            TotalCertificado: '',
            TotalExportado: '',
            RestoExportacion: '',
        });
    }

    updateForm() {
        this.form.setValue({
            TipoMedida: this.solicitudResumenAtestFito.TipoMedida,
            TotalCertificado: this.decimalPipe.transform(this.solicitudResumenAtestFito.TotalCertificado, '1.0-3', 'es'),
            TotalExportado: this.decimalPipe.transform(this.solicitudResumenAtestFito.TotalExportado, '1.0-3', 'es'),
            RestoExportacion: this.decimalPipe.transform(
                this.solicitudResumenAtestFito.TotalCertificado! - this.solicitudResumenAtestFito.TotalExportado!,
                '1.0-3',
                'es',
            ),
        });
    }

    guardRefreshPage(id: number) {
        if ((id && !this.navMenuService.currentSolicitudAtestacion.Id) || this.navMenuService.currentSolicitudAtestacion.Id !== id) {
            this.solicitudAtestFitoService.getSolicitudAtestFito(id).subscribe(result => {
                this.navMenuService.currentSolicitudAtestacion = result;
            });
        }
    }
}
